import { render, staticRenderFns } from "./largebox.vue?vue&type=template&id=1d2004f0&scoped=true"
import script from "./largebox.vue?vue&type=script&lang=js"
export * from "./largebox.vue?vue&type=script&lang=js"
import style0 from "./largebox.vue?vue&type=style&index=0&id=1d2004f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2004f0",
  null
  
)

export default component.exports